// extracted by mini-css-extract-plugin
export default {"sublinks":"CustomerInfoLinks_sublinks__I5Oqq","sublinks_item":"CustomerInfoLinks_sublinks_item__qdpPV","sublinks_item__active":"CustomerInfoLinks_sublinks_item__active__p0cHr"};